export const UPDATE_CURRENT_VIEW_MV = 'UPDATE_CURRENT_VIEW_MV';
export const UPDATE_PLANS_MV = 'UPDATE_PLANS_MV';
export const UPDATE_COVID_MV = 'UPDATE_COVID_MV';
export const UPDATE_SETUP_MV = 'UPDATE_SETUP_MV';
export const UPDATE_REVIEWORDER_MV = 'UPDATE_REVIEWORDER_MV';
export const UPDATE_APPOINTMENT_MV = 'UPDATE_APPOINTMENT_MV';
